const $ = require('jQuery');
const Component = require('./../../Component');
const template = require('../../../template/staticInput.html');
const input_tpl = '<div class="im-static-word-container"><div class="im-static-word" data-index=${index}>${input}</div></div>';

const staticInput = function (options) {
    (function (self) {
        let defaults = {
            template: template,
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
        self.getElement().find('.im-static-words').click(function(evt){
            let _target = $(evt.target);
            if (_target.hasClass('im-static-word')) {
                let inputs = self._data.inputs;
                let index = _target.data('index');
                if (!isNaN(index) && inputs && inputs[index] && inputs[index].length) {
                    self.triggerEvent('staticOutput', inputs[index]);
                }
            }
        });
        self.getElement().find('.im-static-login-btn').click(function(){
            self.triggerEvent('staticLogin');
        });
    })(this);
};

staticInput.prototype = Object.create(Component.prototype);

staticInput.prototype.render = function () {
    let element = this.getElement();
    let inputs = this._data.inputs;
    if (inputs && inputs.length) {
        let html = '';
        let index = 0;
        for(let input of inputs) {
            if (typeof input === 'string') {
                html += input_tpl.replace('${input}', index + 1 + '.' + input).replace('${index}', index);
                index++;
            }
        }
        element.find('.im-static-words').html(html);
    }
};

staticInput.prototype.show = function () {
    Component.prototype.show.call(this);
};

staticInput.prototype.hide = function () {
    Component.prototype.hide.call(this);
};

module.exports = staticInput;
